import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { RespondentThemeWrapper } from '@sm/question-ui/theme-respondent';
import { d as declareVisualization, p as providerFactory } from './utils-ae3e42d4.js';
import { MultipleChoice, CheckBox, ImageChoice } from '@sm/question-ui/respondent-quiz-results';
export { Q as QuestionListController, S as SingleQuestionController } from './controllers-2e1c068a.js';
import '@sm/question-definitions';
import '@sm/question-ui/respondent-survey';
/**
 * Derive the answer layout columns
 * @param answerLayout answer layout from external question
 */

var getAnswerLayoutColumns = function getAnswerLayoutColumns(answerLayout) {
  if (answerLayout === 'VERTICAL') {
    return 1;
  }

  if (answerLayout === 'TWO_COLUMNS') {
    return 2;
  }

  if (answerLayout === 'THREE_COLUMNS') {
    return 3;
  }

  return 'horizontal';
};

var quizAnswersToImageAnswers = function quizAnswersToImageAnswers(quizAnswers, answersImage) {
  return quizAnswers.map(function (ans) {
    var matchingImageAnswer = answersImage.find(function (ansImg) {
      return ansImg.id === ans.answer.id;
    });

    if (!matchingImageAnswer) {
      throw new Error('Image not found'); // TODO: Handle this later
    }

    var answer = matchingImageAnswer;
    return _objectSpread(_objectSpread({}, ans), {}, {
      answer: _objectSpread({}, answer)
    });
  });
};
/**
 * Map the quiz results with the image answers
 * @param quizResults the quizResults provided by the external question
 * @param answersImage the answersImage provided by the external question
 */


var getQuizResultsWithImage = function getQuizResultsWithImage(quizResults, answersImage) {
  return _objectSpread(_objectSpread({}, quizResults), {}, {
    answers: quizAnswersToImageAnswers(quizResults.answers, answersImage)
  });
};

var MultipleChoiceVisualization = function MultipleChoiceVisualization(_ref) {
  var _ref$question = _ref.question,
      _ref$question$layout = _ref$question.layout,
      answerLayout = _ref$question$layout.answerLayout,
      spacing = _ref$question$layout.spacing,
      quizResults = _ref$question.quizResults,
      id = _ref$question.id,
      title = _ref$question.title,
      questionNumber = _ref$question.questionNumber,
      answerNoneOfTheAbove = _ref$question.answerNoneOfTheAbove,
      answerOther = _ref$question.answerOther,
      numberingEnabled = _ref.settings.survey.numberingEnabled;

  // TODO: use a better error handling once we have the error handing
  // pattern designed
  if (!quizResults) {
    /* eslint-disable-next-line no-console */
    console.warn('Missing quiz results in the data');
    return React.createElement(React.Fragment, null);
  }

  var answerLayoutColumns = getAnswerLayoutColumns(answerLayout);
  return React.createElement(MultipleChoice, {
    id: id,
    title: title,
    questionNumber: questionNumber,
    numberingEnabled: numberingEnabled,
    answerNoneOfTheAbove: answerNoneOfTheAbove,
    answerLayoutColumns: answerLayoutColumns,
    spacing: spacing,
    answerOther: answerOther,
    quizResults: quizResults
  });
};

var MultipleChoiceVisualization$1 = declareVisualization(['multiple_choice'], ['respondent-quiz-results'], MultipleChoiceVisualization);

var CheckBoxVisualization = function CheckBoxVisualization(_ref2) {
  var _ref2$question = _ref2.question,
      _ref2$question$layout = _ref2$question.layout,
      answerLayout = _ref2$question$layout.answerLayout,
      spacing = _ref2$question$layout.spacing,
      quizResults = _ref2$question.quizResults,
      id = _ref2$question.id,
      title = _ref2$question.title,
      questionNumber = _ref2$question.questionNumber,
      answerNoneOfTheAbove = _ref2$question.answerNoneOfTheAbove,
      answerOther = _ref2$question.answerOther,
      numberingEnabled = _ref2.settings.survey.numberingEnabled;

  // TODO: use a better error handling once we have the error handing
  // pattern designed
  if (!quizResults) {
    /* eslint-disable-next-line no-console */
    console.warn('Missing quiz results in the data');
    return null;
  }

  var answerLayoutColumns = getAnswerLayoutColumns(answerLayout);
  return React.createElement(CheckBox, {
    id: id,
    title: title,
    questionNumber: questionNumber,
    numberingEnabled: numberingEnabled,
    answerNoneOfTheAbove: answerNoneOfTheAbove,
    answerLayoutColumns: answerLayoutColumns,
    spacing: spacing,
    answerOther: answerOther,
    quizResults: quizResults
  });
};

var CheckBoxVisualization$1 = declareVisualization(['check_box'], ['respondent-quiz-results'], CheckBoxVisualization);

var ImageChoiceVisualization = function ImageChoiceVisualization(_ref3) {
  var _ref3$question = _ref3.question,
      typeId = _ref3$question.typeId,
      quizResults = _ref3$question.quizResults,
      id = _ref3$question.id,
      title = _ref3$question.title,
      questionNumber = _ref3$question.questionNumber,
      answerNoneOfTheAbove = _ref3$question.answerNoneOfTheAbove,
      answersImage = _ref3$question.answersImage,
      numberingEnabled = _ref3.settings.survey.numberingEnabled;

  // TODO: use a better error handling once we have the error handing
  // pattern designed
  if (!quizResults) {
    /* eslint-disable-next-line no-console */
    console.warn('Missing quiz results in the data');
    return React.createElement(React.Fragment, null);
  }

  var isManyAnswers = typeId === 'image_choice_many_answers';
  var quizResultsWithImage = getQuizResultsWithImage(quizResults, answersImage);
  return React.createElement(ImageChoice, {
    id: id,
    title: title,
    questionNumber: questionNumber,
    numberingEnabled: numberingEnabled,
    answerNoneOfTheAbove: answerNoneOfTheAbove,
    quizResults: quizResultsWithImage,
    isManyAnswers: isManyAnswers
  });
};

var ImageChoiceVisualization$1 = declareVisualization(['image_choice_many_answers', 'image_choice_single_answer'], ['respondent-quiz-results'], ImageChoiceVisualization);

var DropdownVisualization = function DropdownVisualization(_ref4) {
  var _ref4$question = _ref4.question,
      _ref4$question$layout = _ref4$question.layout,
      answerLayout = _ref4$question$layout.answerLayout,
      spacing = _ref4$question$layout.spacing,
      quizResults = _ref4$question.quizResults,
      id = _ref4$question.id,
      title = _ref4$question.title,
      questionNumber = _ref4$question.questionNumber,
      answerOther = _ref4$question.answerOther,
      numberingEnabled = _ref4.settings.survey.numberingEnabled;

  // TODO: use a better error handling once we have the error handing
  // pattern designed
  if (!quizResults) {
    /* eslint-disable-next-line no-console */
    console.warn('Missing quiz results in the data');
    return React.createElement(React.Fragment, null);
  }

  var answerLayoutColumns = getAnswerLayoutColumns(answerLayout);
  return React.createElement(MultipleChoice, {
    id: id,
    title: title,
    questionNumber: questionNumber,
    numberingEnabled: numberingEnabled,
    answerNoneOfTheAbove: null,
    answerLayoutColumns: answerLayoutColumns,
    spacing: spacing,
    answerOther: answerOther,
    quizResults: quizResults
  });
};

var DropdownVisualization$1 = declareVisualization(['dropdown'], ['respondent-quiz-results'], DropdownVisualization);
var visualizationList = [MultipleChoiceVisualization$1, CheckBoxVisualization$1, ImageChoiceVisualization$1, DropdownVisualization$1];
var ProviderHelper = providerFactory(visualizationList);

var QuizResultsCapabilityProvider = function QuizResultsCapabilityProvider(_ref5) {
  var settings = _ref5.settings,
      children = _ref5.children;
  return React.createElement(ProviderHelper, {
    value: {
      capability: 'respondent-quiz-results',
      upstreamActions: null,
      renderProps: null,
      settings: settings
    }
  }, React.createElement(RespondentThemeWrapper, null, children));
};

export { QuizResultsCapabilityProvider, visualizationList as QuizResultsVisualizationList };